import { mediaData } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-10">
          <span className="w-1 h-6 bg-secondary-500 rounded-full"></span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">精彩视频</h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {mediaData.slice(0, 3).map((item) => (
            <div
              key={item.id}
              className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-secondary-200/60 transition-all duration-200 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors duration-200 flex items-center justify-center">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-white/90 text-primary-500 group-hover:bg-primary-500 group-hover:text-white transition-all duration-200">
                    <i className="ri-play-fill text-2xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-3 right-3 px-2 py-0.5 text-[11px] font-medium bg-black/60 text-white rounded whitespace-nowrap">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base text-foreground-900 mb-2 line-clamp-2">{item.title}</h3>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {item.duration}
                  </span>
                </div>
              </div>
            </div>
          ))}

          {mediaData.slice(3).map((item) => (
            <div
              key={item.id}
              className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-secondary-200/60 transition-all duration-200 cursor-pointer lg:col-span-3"
            >
              <div className="flex flex-col sm:flex-row">
                <div className="relative sm:w-[360px] shrink-0 aspect-video sm:aspect-auto overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors duration-200 flex items-center justify-center">
                    <div className="w-14 h-14 flex items-center justify-center rounded-full bg-white/90 text-primary-500 group-hover:bg-primary-500 group-hover:text-white transition-all duration-200">
                      <i className="ri-play-fill text-2xl ml-0.5"></i>
                    </div>
                  </div>
                  <span className="absolute bottom-3 right-3 px-2 py-0.5 text-[11px] font-medium bg-black/60 text-white rounded whitespace-nowrap">
                    {item.duration}
                  </span>
                </div>
                <div className="p-5 flex flex-col justify-center flex-1">
                  <h3 className="font-heading text-lg text-foreground-900 mb-2">{item.title}</h3>
                  <div className="flex items-center gap-4 text-xs text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {item.views} 次观看
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line"></i>
                      {item.duration}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}